import React from 'react'
import { ClientDetailContainer } from '@/components/containers/client-detail'

export const ClientDetailPage: React.FC = () => {
  return <ClientDetailContainer />
}
